import api from 'api';
import { BoxWrapper, Button, Prompt } from 'components/Base';
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TableRow } from '@material-ui/core';
import { errHelper, Notify, pluralise } from 'utils';
import './providerPlatform.scss';
import Table from '@material-ui/core/Table';
import TableComponents from 'components/Table';
import Icons from 'components/Icons';
import Tooltip from '../../../Base/Tooltip/Tooltip';
import { policyTypes } from 'components/ProviderPlatformCharges/util';
import { connect } from 'react-redux';
import selectors from 'store/selectors';

type PlatformProviderSetProps = any;

const PlatformProviderSet: React.FC<PlatformProviderSetProps> = ({
  chargesGroup,
  providerTypes,
  platformTypes,
  addChargeSet,
  i,
  editCharge,
  deleteChargeItem,
  isFirmAdmin
}) => {
  const [isDeletePromptOpen, setIsDeletePromptOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const getPlatformType = (platform: any) => {
    return platformTypes.find(
      (pt: any) => Number(pt.value) === platform
    ) as any;
  };

  const getProviderTypes = (provider: any) => {
    return providerTypes.find(
      (pt: any) => Number(pt.value) === provider
    ) as any;
  };

  const useStyles = makeStyles(() => ({
    table: {
      width: 'calc(100% + 1px)' // fix chrome bug,
    }
  }));

  const classes = useStyles();

  const deleteCharge = async (id: number) => {
    try {
      setIsDeleting(true);
      await api.providerPlatformChargesApi.deleteProviderPlatformCharge(id);
      const index = chargesGroup.findIndex((cg: any) => cg.id === id);
      const charges = chargesGroup;
      charges.splice(index, 1);
      deleteChargeItem(id);
      setIsDeleting(false);
      Notify.success(`You have deleted charge ${id}`);
    } catch (err) {
      errHelper(err);
    }
  };

  const chargeTypes: any = {
    1: 'Tiered',
    2: 'Stepped',
    3: 'Fixed'
  };

  return (
    <BoxWrapper
      style={{ margin: '1rem' }}
      title={getPlatformType(chargesGroup[0].policy_platform).name}
    >
      <Table className={classes.table}>
        <TableComponents.TableHead cells={['Provider', 'Type', '', '']} />
        <TableComponents.TableBody>
          {chargesGroup.map((cd: any) => {
            return (
              <>
                {' '}
                <TableRow>
                  <TableComponents.TableCell
                    style={{
                      fontWeight: '500',
                      width: '40%'
                    }}
                  >
                    {getProviderTypes(cd.policy_provider).name}
                  </TableComponents.TableCell>
                  <TableComponents.TableCell
                    style={{
                      fontWeight: '500'
                    }}
                  >
                    {chargeTypes[cd.charge_type]} (
                    {cd.charge_value_type === 1 ? '£' : '%'})
                  </TableComponents.TableCell>
                  <TableComponents.TableCell
                    style={{
                      fontWeight: '500'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}
                    >
                      {cd.policy_type.length}{' '}
                      {pluralise(cd.policy_type.length, 'policy type')}
                      <Tooltip
                        text={cd.policy_type
                          .map((policyType: string) => {
                            const selectedPolicy = policyTypes.find(
                              policy =>
                                Number(policy.value) === Number(policyType)
                            );
                            return selectedPolicy ? selectedPolicy.name : '';
                          })
                          .join(', ')}
                      />
                    </div>
                  </TableComponents.TableCell>
                  <TableComponents.TableCell
                    style={{
                      width: '100px',
                      fontWeight: '500'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}
                    >
                      <Button
                        onClick={() => {
                          editCharge(cd);
                        }}
                      >
                        {isFirmAdmin ? 'Edit' : 'View'}
                      </Button>
                      {isFirmAdmin && (
                        <Icons.DeleteIcon
                          onClick={() => setIsDeletePromptOpen(true)}
                          style={{
                            cursor: 'pointer'
                          }}
                        />
                      )}
                      <Prompt
                        isOpen={isDeletePromptOpen}
                        title={`Are you sure you want to delete this charge?`}
                        confirmAction={() => {
                          deleteCharge(cd.id);
                          setIsDeletePromptOpen(false);
                        }}
                        isProcessing={isDeleting}
                        cancelAction={() => setIsDeletePromptOpen(false)}
                      />
                    </div>
                  </TableComponents.TableCell>
                </TableRow>
              </>
            );
          })}
        </TableComponents.TableBody>
      </Table>
      {isFirmAdmin && (
        <div style={{ padding: '1rem' }}>
          <Button
            onClick={() =>
              addChargeSet(
                i,
                chargesGroup[0].policy_platform,
                chargesGroup[0].policy_provider
              )
            }
          >
            Add charge
          </Button>
        </div>
      )}
    </BoxWrapper>
  );
};

export default connect((state: any) => ({
  isFirmAdmin: selectors.advisorSelectors.isFirmAdmin(state)
}))(PlatformProviderSet);
